<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="facebook-ads-tree"
>
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <ul>
      <li class="mat-tree-node">
        <div class="mat-tree-node">
          <!-- <button mat-icon-button disabled></button>-->
          <div class="category-name">
            {{
              "brand.campaign.promoAds.facebookTargeting." + node.name
                | translate
            }}
          </div>
        </div>
      </li>
      <li class="mat-tree-node">
        <!-- use a disabled button to provide padding for tree leaf -->
        <!-- <button mat-icon-button disabled></button>-->
        <div class="input-wrap">
          <mat-label>{{
            "brand.campaign.promoAds.facebookTargetingStartTyping" | translate
          }}</mat-label>
          <input
            type="text"
            [disabled]="!campaign.isEditable"
            class="list-search-input"
            name="{{ 'searchKey' + node.code }}"
            [(ngModel)]="node.searchKey"
            [attr.aria-label]="
              'brand.campaign.promoAds.facebookTargetingType' | translate
            "
            (input)="loadSearchTargets(node, $event.target.value)"
            matInput
          />
          <div *ngIf="node.loadingFacebookTargetingTypes" class="input-loader">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
          <mat-icon
            (click)="clearNodeSearch(node)"
            class="input-clear"
            *ngIf="node.searchKey && !node.loadingFacebookTargetingTypes"
            >close</mat-icon
          >
        </div>
      </li>
      <li
        *ngFor="let targetingType of node.facebookTargetingTypes"
        (click)="addFacebookTargeting(node, targetingType)"
      >
        <div
          class="list-search-result"
          [ngClass]="{
            'result-selected': targetingTypeIsSelected(
              node.selectedChildren,
              targetingType
            )
          }"
        >
          {{ targetingType.name }}
        </div>
      </li>
      <li
        *ngIf="
          node.facebookTargetingTypes.length === 0 &&
          node.searchKey &&
          !node.loadingFacebookTargetingTypes
        "
      >
        <div class="list-search-result">
          {{ "shared.noResultsFound" | translate }}
        </div>
      </li>
      <li *ngIf="node.selectedChildren.length > 0" class="mat-tree-node">
        <!-- use a disabled button to provide padding for tree leaf -->
        <!--  <button mat-icon-button disabled></button>-->
        <mat-chip-listbox class="list-chips">
          <mat-chip-option
            color="orange"
            (click)="deleteFacebookTargeting(node, chipTargetingType)"
            *ngFor="let chipTargetingType of node.selectedChildren"
          >
            <mat-icon *ngIf="campaign.isEditable">close</mat-icon>
            {{ chipTargetingType.name }}
          </mat-chip-option>
        </mat-chip-listbox>
      </li>
    </ul>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
    <li>
      <div class="mat-tree-node">
        <button
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'toggle ' + node.name"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
          </mat-icon>
        </button>
        <div class="category-name">{{ node.name }}</div>
      </div>
      <ul [class.facebook-ads-tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
